import { type ReactElement } from 'react';
import { Box, Text } from '@citibox-panel/ui';

export interface ExclusionSummaryProps {
  carrierName: string;
}

// What being on this carrier's list does — and, as importantly, what it does NOT do: the account
// stays, and so does every other carrier. It captions the block beneath it, so no heading of its own.
//
// TODO: i18n — copy en ES hasta Fase 1.
export function ExclusionSummary({ carrierName }: ExclusionSummaryProps): ReactElement {
  return (
    <Box sx={{ maxWidth: '62ch', mb: 2 }}>
      <Text variant="body1">
        {`${carrierName} no puede reservar buzón a los «Usuarios» de esta lista. Siguen registrados y reciben del resto de carriers; al quitarlos vuelven a recibir también de ${carrierName}.`}
      </Text>
    </Box>
  );
}
